// extracted by mini-css-extract-plugin
module.exports = {"pill":"Pill_pill__Sv_Ug"};